import React, {FunctionComponent} from "react";
import {RouteProps, useSearchParams} from "react-router-dom";
import Layout from "../components/layout/Layout";
import BookingList from "../components/molecules/list/BookingList";
import {useIntl} from "react-intl";
import PageTitle from "../components/molecules/header/PageTitle";
import HeaderButtonGroup, {HeaderStateButton} from "../components/molecules/header/HeaderButtonGroup";
import BookingPendingList from "../components/molecules/list/BookingPendingList";
import {BookingStatus, DefaultPendingBookingState} from "../interfaces/BookingInterfaces";
import {profileUtils} from "../utils/profileUtils";
import useSearchFilter from "hooks/useSearchFilter";

const BookingListView: FunctionComponent<RouteProps> = () => {
  const intl = useIntl();
  const [params] = useSearchParams();

  const initialSearchState: DefaultPendingBookingState = {
    bookingId: params.get("bookingId") || "",
    displayPending: !!params.get("displayPending"),
    displayClosed: !!params.get("displayClosed"),
  };

  const {searchObject, updateSearchField, onReset} = useSearchFilter<DefaultPendingBookingState>(initialSearchState);

  const stateFilterButtons: HeaderStateButton[] = !profileUtils.isAccountant() ? [
    {
      title: intl.formatMessage({id: "booking_to_do"}),
      onclick: () => {
        updateSearchField("bookingId", "");
        updateSearchField("displayPending", false);
        updateSearchField("displayClosed", false);
      },
      active: searchObject?.displayPending === false && searchObject?.displayClosed === false
    },
    {
      title: intl.formatMessage({id: "booking_pending"}),
      onclick: () => {
        updateSearchField("bookingId", "");
        updateSearchField("displayPending", true);
        updateSearchField("displayClosed", false);
        onReset({displayPending: true, displayClosed: false});
      },
      active: searchObject?.displayPending === true
    },
    {
      title: intl.formatMessage({id: "purchase_header_close"}),
      onclick: () => {
        updateSearchField("bookingId", "");
        updateSearchField("displayPending", false);
        updateSearchField("displayClosed", true);
      },
      active: searchObject?.displayClosed === true
    },
  ] : [
    {
      title: intl.formatMessage({id: "purchase_header_close"}),
      onclick: () => {
        updateSearchField("bookingId", "");
        updateSearchField("displayPending", false);
        updateSearchField("displayClosed", true);
      },
      active: searchObject?.displayClosed === true
    }
  ];

  return (
    <Layout>
      <div className="epow-content-body d-flex flex-column">
        <div className="d-flex mb-5">
          <PageTitle pageTitle={intl.formatMessage({id: "bookings_title"})}></PageTitle>
          <HeaderButtonGroup className="d-flex flex-1 justify-content-center me-5" buttonList={stateFilterButtons}/>
        </div>
        {searchObject?.displayPending?
          <BookingPendingList defaultPendingBookingToOpenId={searchObject?.bookingId} updateDefaultPendingBookingId={updateSearchField}/>
          : searchObject?.displayClosed?
            <BookingList defaultPendingBookingToOpenId={searchObject?.bookingId} status={BookingStatus.CLOSED}/> :
            <BookingList status={BookingStatus.TO_DO}/>
        }
      </div>
    </Layout>
  );
}

export default BookingListView
